import React, { Fragment, useEffect, useState } from "react";
import config from "../../config/app.json";
import { DropShadowWrapper, GridDefaultImage, GridImage, ImageContainer, VIGNETTE, Loader } from "./styledComponent";
import { ReturnSvgFilter } from "../ReturnSvgFilter";
import { getRGBAForDuotone } from "./Helpers/ColorConversion";
import { GRID_CLASSES, getFrameClipFilterId, getFrameClipFilterSvgId, getFrameClipVignetteId } from "../../helpers/frameHelper";

const assetUrl = config["APPICONS"][config["APPICONS"]["current"]];
const appUrl = config['APPICONS'][config['APPICONS']['current']];

function FilterItem(props) {
    const {
        clip, ItemID, filterCode, filterId, browserName, idPrefix
    } = props;
    return (
        <React.Fragment>
            <div>
                <svg
                    id={getFrameClipFilterSvgId(ItemID, clip, idPrefix)}
                    style={
                        browserName === "Firefox"
                            ? { width: "0", height: "0", display: "block" }
                            : { display: "none" }
                    }
                >
                    <defs>
                        <filter colorInterpolationFilters="sRGB" id={filterId}>
                            <ReturnSvgFilter filterCode={filterCode} />
                        </filter>
                    </defs>
                </svg>
            </div>
        </React.Fragment>
    );
}

export function GridAreaComponent(props) {
    const {
        droppableCellData,
        showImage,
        showGridArea,
        cellId,
        itemId,
        src,
        containerStyles,
        imageRef,
        imageContainerRef,
        filterData,
        thumb,
        idPrefix,
        onLoadData,
    } = props;

    const [loading, setLoading] = useState(true);
    let imageSource = src;
    useEffect(() => {
        let image = new Image();
        setLoading(true);
        image.onload = () => {
            setLoading(false);
        };
        image.onerror = () => {
            setLoading(false);
        };
        image.src = thumb;
    }, [imageSource]);

    const workspaceWidth = props.projectWidth;
    const workspaceHeight = props.projectHeight;

    const onLoadImage = (status, imgSrc) => {
        try {
            if (status === true) {
                const imageId = `${cellId}-${itemId}`; 
                console.log(status, imgSrc, onLoadData, imageId)
                onLoadData(imageId);
            }
        } catch (error) {
            console.log(error)
        }
    }

    if (showGridArea && droppableCellData && !droppableCellData.get("imgDetails")) {
        if (containerStyles && containerStyles.background) {
            return <GridDefaultImage className={GRID_CLASSES["BG_COLOR"]} assetUrl={assetUrl} style={{ background: containerStyles.background }} />;
        }
        return <GridDefaultImage className={GRID_CLASSES["BG_COLOR"]} assetUrl={assetUrl} />;
    }

    if (showGridArea) {
        let duotone;
        let opacity = 1;
        let imgDetails = droppableCellData.get("imgDetails");
        let filterCode = !filterData ? "6464646464640032" : filterData;
        const vignetteValue = parseInt(filterCode.substr(12, 2), 16);
        const vignetteId = getFrameClipVignetteId(itemId, cellId, idPrefix);
        const filterId = getFrameClipFilterId(itemId, cellId, filterCode, idPrefix);
        if (imgDetails && imgDetails.get("imageEffectsData")) {
            const vignetteItemId = `${cellId}-vignette-${itemId}`;
            let i = imgDetails
                .get("imageEffectsData")
                .findIndex((data) => data.get("effectName") === "duotone");
            let highlights, shadow;
            if (i >= 0) {
                highlights = getRGBAForDuotone(
                    imgDetails.getIn(["imageEffectsData", i, "highlights"])
                );
                shadow = getRGBAForDuotone(
                    imgDetails.getIn(["imageEffectsData", i, "shadow"])
                );
                duotone = (
                    <Fragment>
                        <GridImage
                            alt="duo"
                            src={imageSource}
                            style={{
                                position: "absolute",
                                top: "0px",
                                filter: `url(#filter_${itemId}_${cellId}_duotone)`,
                                opacity: 1,
                            }}
                        />
                        <div>
                            <svg
                                id={`svgFilter_${itemId}_${cellId}_duotone`}
                                style={{
                                    width: "0",
                                    height: "0",
                                    position: "absolute",
                                }}
                            >
                                <defs>
                                    <filter
                                        colorInterpolationFilters={"sRGB"}
                                        id={`filter_${itemId}_${cellId}_duotone`}
                                    >
                                        <feColorMatrix
                                            type="matrix"
                                            values=".33 .33 .33 0 0
                                                            .33 .33 .33 0 0
                                                            .33 .33 .33 0 0
                                                            0 0 0 1 0"
                                        ></feColorMatrix>
                                        <feComponentTransfer
                                            colorInterpolationFilters="sRGB"
                                            result="duotone"
                                        >
                                            <feFuncR
                                                type="table"
                                                tableValues={`${shadow.r / 255
                                                    }  ${highlights.r / 255}`}
                                            ></feFuncR>
                                            <feFuncG
                                                type="table"
                                                tableValues={`${shadow.g / 255
                                                    }  ${highlights.g / 255}`}
                                            ></feFuncG>
                                            <feFuncB
                                                type="table"
                                                tableValues={`${shadow.b / 255
                                                    }  ${highlights.b / 255}`}
                                            ></feFuncB>
                                            <feFuncA
                                                type="table"
                                                tableValues="0 1"
                                            ></feFuncA>
                                        </feComponentTransfer>
                                        <ReturnSvgFilter
                                            filterCode={filterId}
                                            vignetteId={vignetteItemId}
                                            projectDimensions={{
                                                width: workspaceWidth,
                                                height: workspaceHeight,
                                            }}
                                        />
                                    </filter>
                                </defs>
                            </svg>
                        </div>
                    </Fragment>
                );
                opacity = 1 - shadow.a;
            }
        }

        /*
        let imgSrc = thumb;
        let isVideo = false;
        let videoSrc = src;

        if (imgDetails) {
            const type = imgDetails.get("type");
            const subType = imgDetails.get("subType");
            if (!imageHovered) {
                if (type === "STOCKVID" || (type === "UPLOADS" && subType === "UPVIDEO") || (type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO") || subType === "OBGVID") {
                    if ((type === "UPLOADS" && subType === "UPVIDEO")) {
                        if (!imgSrc.includes("https")) {
                            imgSrc = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + imgSrc
                        }
                        isVideo = true;
                        videoSrc = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + videoSrc;
                    } else if (type === "STOCKVID") {
                        if (!imgSrc.includes("https")) {
                            imgSrc = config[type][config[type].onload] + imgSrc;
                        }
                        isVideo = true;
                        if(!src.includes("https")) {
                            videoSrc = config[type][config[type].workspace] + videoSrc;
                        }
                    } else if ((type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO")) {
                        isVideo = true;
                    } else if (subType === "OBGVID") {
                        if (!imgSrc.includes("https")) {
                            imgSrc = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${imgSrc}`;
                        }
                        isVideo = true;
                        videoSrc = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${videoSrc}`;
                    }
                }
            }
        }

        if (!isVideo) {
            videoSrc = "";
            imgSrc = imageSource;
        }
        */

        if (loading) {
            return (
                <Loader>
                    <img alt="loader" src={appUrl + "/images/chr-loading.gif"} />
                </Loader>
            )
        }

        return (
            <ImageContainer
                ref={imageContainerRef}
                className={`grid_image_container_${cellId} ${GRID_CLASSES["BG_COLOR"]}`}
                style={containerStyles}
            >
                {showImage &&
                        <Fragment>
                            {duotone}
                            <GridImage
                                clip={cellId}
                                data-alt={"cellImage"}
                                ref={imageRef}
                                // src={imgSrc}
                                src={imageSource}
                                alt="cellImage"
                                style={{ opacity: opacity, filter: `url(#${filterId})`,}}
                                className={`img-item ${GRID_CLASSES["INNER_IMAGE"]}`}
                                onLoad = {() => onLoadImage(true, imageSource)}
                                onError = {() => onLoadImage(false, imageSource)}
                            />
                            {/* <GridVideo src={videoSrc} crossorigin="anonymous" className={getFrameVideoClass(itemId, cellId, idPrefix)} style={{ display: isImageHovered ? "none" : "block", filter: `url(#${filterId})`, }} /> */}
                            <VIGNETTE
                                id={vignetteId}
                                className="vignette"
                                style={{
                                    "--vignette": vignetteValue * 0.007,
                                }}
                            />
                            <FilterItem
                                key={`${cellId}_filter`}
                                clip={cellId}
                                filterId={filterId}
                                filterCode={filterData}
                                ItemID={itemId}
                                browserName={props.browserName}
                                idPrefix={idPrefix}
                            />
                        </Fragment>
                }
            </ImageContainer>
        );
    }

    return <GridDefaultImage className={GRID_CLASSES["BG_COLOR"]} assetUrl={assetUrl} />;
}


// WEBPACK FOOTER //
// ./src/components/Grid/GridAreaComponent.js